import { getAuthToken } from "@/lib/auth";
import { FunctionComponent, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const AuthRoute: FunctionComponent = () => {
  const navigate = useNavigate();
  const authToken = getAuthToken();

  useEffect(() => {
    if (authToken) {
      // If user is already authenticated, redirect to home page
      navigate("/");
    }
  }, [authToken, navigate]);

  // Only render the auth pages if user is not authenticated
  return !authToken ? <Outlet /> : null;
};

export default AuthRoute;
